<template lang="pug">

  v-row.ma-0
    v-snackbar(v-model="showSnackBar" :color="snackbarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    v-col.pa-0.pr-2.pl-2(cols="12")
      v-card.elevation-4.title.card-style(flat )
        v-card-title.text-h5.font-weight-bold.pa-0
          v-row.ma-0
            v-col(cols="10") {{ $t('dashboardPage.deliveryTitle') }}
            v-col.text-end.pa-0.pt-3.pr-1(cols="2" )
              v-btn.text-center(:loading="loading" icon v-if="loading" )
                v-icon.font-weight-bold(medium color="black" ) fas fa-spinner
        v-row.ma-0.toolbar-style
          v-col.text-start(cols="2" md="3")
            v-btn.text-end.pl-md-4(@click="onPrevDayClick" icon)
              v-icon.text-start fas fa-chevron-double-left
          v-col.text-h5.font-weight-bold.text-center(cols="8" md="6")
            span.pt-2 {{getTitle}} {{getDayName}} {{getFormattedDate}}
          v-col.text-end(cols="2" md="3")
            v-btn.text-end.pr-md-4(@click="onNextDayClick" icon)
              v-icon.text-end fas fa-chevron-double-right
        v-card-text.pa-0(v-if="isDailyMenu" v-for="(item,idx) in business" :key="idx")
          v-row.ma-0
            v-col.pa-0(cols="12")
              v-card.card-style()
                v-card-title
                  v-row.ma-0(no-gutters )
                    v-col.text-start(cols="9" md="6") {{item.name}}
                    v-col.text-end.pr-md-4(cols="3" md="6")
                      v-btn( @click="showDetailReservationSummary(item)" color="white" )
                        v-icon.pr-2(color="#81ccc5") fas fa-truck
                        span.text--black(v-if="$vuetify.breakpoint.mdAndUp") Rozvoz
                v-card-text.flex-shrink-0.flex-grow-1.pt-0(v-for="[key, value] in data" :key="key" )
                    DashboardReservationSummaryItemDetail(:groupName="key" :value="getBusinessFilteredData(value,item)" :date="date")
        v-card-text.pb-4.flex-shrink-0.flex-grow-1.pt-6.text-center(v-else)
          span.text-center.text-h5.font-weight-bold {{ $t('dashboardPage.noFoodMenuOrder') }}

</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import moment from "moment/moment";
import i18n from "@/i18n";
import DashboardReservationSummaryItemDetail from "@/components/DashboardReservationSummaryItemDetail.vue";
import {usePiniaStore} from "@/store/piniaStore";
import {COUNTDOWN} from "@/constants";
import BusinessReservationSummary from "@/components/BusinessReservationSummary.vue";
import axios from "@/plugins/axios";
import MenuGroupSummary from "@/model/MenuGroupSummary";
import CustomerModel from "@/model/customer/CustomerModel";
import Businesses from "@/model/business/Businesses";


@Component({
    components: {DashboardReservationSummaryItemDetail,
      }
})
export default class DashboardReservationSummaryDetail extends Vue {
    $refs!: {
        panel: Vue & { toggle(): void }
    }

    private date: string = moment().format('YYYY-MM-DD')
    private summaryData: MenuGroupSummary[] | null =  []
    private piniaStore = usePiniaStore()
    private data: Map<string, {title: string, value: number ,food: string, status: boolean, icon: string,totalPortion: number}[]> = new Map();
    private business: Businesses[] = []
    private loading: boolean = false
    private showSnackBar: boolean = false
    private snackbarColor: string = ''
    private snackBarMessage: string | null = null
    private timeOutId: any | null = null
    private actuallyDate: string = ''
    private selectedBusiness: any | null = null
    private businessList: Businesses[] = []
    private customers: CustomerModel[] | null =  []

    get isDailyMenu ():boolean {
      if(this.summaryData && this.summaryData[0] && this.summaryData[0].foodItemSummary.length > 0) {
        return true
      } else {
        return false
      }
    }

    get getTitle (): string {
      if(this.date) {
        if(this.date === moment().format('YYYY-MM-DD')) {
          return this.$t('dashboardPage.today').toString()
        } else if (this.date === moment().add(1,'day').format('YYYY-MM-DD')) {
          return this.$t('dashboardPage.tomorrow').toString()
        } else if (this.date === moment().subtract(1,'day').format('YYYY-MM-DD')) {
          return this.$t('dashboardPage.yesterday').toString()
        } else {
          return ''
        }
      } else {
        return ''
      }
    }


    get getDayName (): string {
        if(this.summaryData) {
            this.summaryData.forEach((item: MenuGroupSummary) => {
                this.date = item.date
            })
        }
        if(this.date) {
            return moment(this.date, 'YYYY-MM-DD').locale(i18n.locale).format('dddd')
        } else {
            return ''
        }
    }


    get getFormattedDate (): string {
        if(this.summaryData) {
            this.summaryData.forEach((item: MenuGroupSummary) => {
                this.date = item.date
            })
        }
        if(this.date) {
            return moment(this.date, 'YYYY-MM-DD').format('D.M.YYYY')
        } else {
            return ''
        }
    }

  getBusinessFilteredData (value: any[], item: any): any {
      return value.filter((i: any) => i.business === item.id)
  }

  showDetailReservationSummary (item: Businesses): void {
    this.selectedBusiness = item
    this.$router.push(
        {name: 'BusinessReservationSummary',
          params: {
            date: this.date,
            customer: this.selectedBusiness
          }})
  }

    countDownTimer () {
      this.timeOutId = setTimeout(() => {
        this.fetchSummaryData(this.date)
      },COUNTDOWN)
    }

    onNextDayClick() : void {
      const payload: string = moment(this.date, 'YYYY-MM-DD').add(1,'day').format('YYYY-MM-DD')
      this.fetchSummaryData(payload)
    }

    onPrevDayClick() : void {
      const payload: string = moment(this.date, 'YYYY-MM-DD').subtract(1,'day').format('YYYY-MM-DD')
      this.fetchSummaryData(payload)
    }


    async fetchSummaryData (payload: string): Promise<void> {
      clearTimeout(this.timeOutId)
      this.loading = true

      try {
        const response = await this.piniaStore.fetchSummaryMenuGroupSlot(payload)
        this.loading = false
        this.summaryData = response.data
        const data: Map<string, {
          title: string,
          value: number,
          food: string,
          status: boolean,
          icon: string,
          totalPortion: number
          order: number,
          business: string}[]> = new Map();
        this.summaryData?.forEach((item: MenuGroupSummary) => {
          item.foodItemSummary.forEach((i: any) => {
            i.menuGroupSlots.forEach((a: any) => {
              a.menuGroup.tags.forEach((b: any) => {
                this.customers!.forEach((y: CustomerModel) => {
                  y.businesses.forEach((d: Businesses) => {
                    if(!this.business.includes(d)) {
                      this.business.push(d)
                    }
                    if(!this.business.includes(d)) {
                      this.business.push(d)
                    }

                  })


                })


                b.title
                if (data.get(a.menuGroup.title)) {
                  if (!data.get(a.menuGroup.title)!.find((d: any) => d.title === a.code) && i.collatedStatusSummary.toBeDeliveredCount > 0) {
                    data.get(a.menuGroup.title)!.push({
                      title: a.code,
                      value: i.collatedStatusSummary.toBeDeliveredCount,
                      food: i.foodItem.title,
                      status: true,
                      icon: b.iconClass,
                      totalPortion: i.totalPortionsCount,
                      order: a.order,
                      business: a.menuGroup.business.id
                    })
                  }
                } else if (i.collatedStatusSummary.toBeDeliveredCount > 0) {
                  data.set(a.menuGroup.title, [{
                    title: a.code,
                    value: i.collatedStatusSummary.toBeDeliveredCount,
                    food: i.foodItem.title,
                    status: true,
                    icon: b.iconClass,
                    totalPortion: i.totalPortionsCount,
                    order: a.order,
                    business: a.menuGroup.business.id
                  }])
                }
              })
            })
          })
        })
        this.data = data
      } catch (e) {
        this.showSnackBar = true
        this.snackbarColor = 'error'
        this.snackBarMessage = this.$t('errors.fetchDataError').toString()
      }  finally {
        this.countDownTimer()
      }
    }

    async fetchBusiness (): Promise<void> {
      try{
        const response = await axios.get('/api/business')
        this.businessList = response.data
      } catch (e) {

      }
    }

    async fetchCustomers ():Promise<void> {
      try {
        const response = await axios.get(`/api/customer`)

        this.customers = response.data
      } catch (e) {

      }

    }

    beforeDestroy () {
      clearTimeout(this.timeOutId)
    }

    mounted () {
        this.fetchSummaryData(this.date)
        this.fetchBusiness()
        this.fetchCustomers()
        this.actuallyDate = this.date
    }
}
</script>

<style lang="stylus" scoped>
.toolbar-style
  background-color white
.card-style
  background-color #e5e5ee

</style>